import {getMPJSAPIData} from '../../api/api'
import {Toast} from 'vant'
import $ from 'jquery'

let wx = require('weixin-js-sdk')
// 分享
export function getWXSDKSetting(shareData, succCallback) {
    return _getMPJSAPIData(shareData, succCallback)
}
// 定位
export function getWXSDKLocation() {
    return _getWXSDKLocation()
}

function _getMPJSAPIData(shareData, succCallback) {
    // 解决ios下分享的时候出现的问题，这里urlencode，后端urldecode
    let callurl = window.location.href
    if (window.__wxjs_is_wkwebview && window.entryUrl) {
        callurl = window.entryUrl
    }
    // alert('location[0]:'+location.href.split('#')[0])
    // alert('location:'+location.href)
    // alert('callurl:'+callurl)
    // alert('entryUrl:'+window.entryUrl)
    // console.log('callurl',callurl)
    // console.log('shareData',shareData)
    callurl = encodeURIComponent(callurl)    
    //如果是anroid，在页面上config，如果是ios，则直接分享
    let ua = window.navigator.userAgent.toLowerCase()
    if (/micromessenger/.test(ua)) {
        if(window.__wxjs_is_wkwebview){
            //iOS
            wx.ready(function () {
                // 需在用户可能点击分享按钮前就先调用
                // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
                // console.log('title',shareData.title)
                // console.log('desc',shareData.desc)
                // console.log('link',shareData.link)
                // console.log('imgUrl',shareData.imgUrl)
                let shareData1 = {
                    title: shareData.title, // 分享标题
                    desc: shareData.desc, // 分享描述
                    link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareData.imgUrl, // 分享图标
                    success: function () {
                        // 设置成功
                        console.log('设置分享给朋友成功')
                        // console.log('succCallback',succCallback)
                        // alert('分享朋友成功')
                        if (succCallback) {
                            succCallback()
                        }
                    },
                    fail: function (res) {
                        console.log('shareData1 fail',res)
                    }
                }
                let shareData2 = {
                    title: shareData.title, // 分享标题
                    link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareData.imgUrl, // 分享图标
                    success: function () {
                        // 设置成功
                        // console.log('设置分享给朋友成功')
                        // alert('分享朋友成功')
                        if (succCallback) {
                            succCallback()
                        }
                    },
                    fail: function (res) {
                        console.log('shareData2 fail',res)
                    }
                }
                if (wx.onMenuShareAppMessage) {
                    // 微信文档中提到这两个接口即将弃用，故判断
                    wx.onMenuShareAppMessage(shareData1)
                    wx.onMenuShareTimeline(shareData2)
                } else {
                    wx.updateAppMessageShareData(shareData1)
                    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
                    wx.updateTimelineShareData(shareData2)
                }
            })
        }
        else{
            //Android
            getMPJSAPIData({
                data: {
                    url: callurl
                },
                success: data => {
                    // console.log('data',data)
                    let wxParams = data.data
                    wx.config({
                        debug: false,
                        appId: wxParams.appid,
                        timestamp: wxParams.timestamp,
                        nonceStr: wxParams.noncestr,
                        signature: wxParams.signature,
                        openTagList: ['wx-open-launch-app'],
                        jsApiList: [
                            'onMenuShareAppMessage', // 1.0 分享到朋友
                            'onMenuShareTimeline', // 1.0分享到朋友圈
                            'updateAppMessageShareData', // 1.4 分享到朋友
                            'updateTimelineShareData' // 1.4分享到朋友圈
                        ]
                    }),
                    wx.error(function(res){
                        console.log('wx.error',res)          
                    }),
                    wx.ready(function () {
                        // 需在用户可能点击分享按钮前就先调用
                        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
                        // console.log('title',shareData.title)
                        // console.log('desc',shareData.desc)
                        // console.log('link',shareData.link)
                        // console.log('imgUrl',shareData.imgUrl)
                        let shareData1 = {
                            title: shareData.title, // 分享标题
                            desc: shareData.desc, // 分享描述
                            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: shareData.imgUrl, // 分享图标
                            success: function () {
                                // 设置成功
                                console.log('设置分享给朋友成功')
                                // console.log('succCallback',succCallback)
                                // alert('分享朋友成功')
                                if (succCallback) {
                                    succCallback()
                                }
                            },
                            fail: function (res) {
                                console.log('shareData1 fail',res)
                            }
                        }
                        let shareData2 = {
                            title: shareData.title, // 分享标题
                            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: shareData.imgUrl, // 分享图标
                            success: function () {
                                // 设置成功
                                // console.log('设置分享给朋友成功')
                                // alert('分享朋友成功')
                                if (succCallback) {
                                    succCallback()
                                }
                            },
                            fail: function (res) {
                                console.log('shareData2 fail',res)
                            }
                        }
                        if (wx.onMenuShareAppMessage) {
                            // 微信文档中提到这两个接口即将弃用，故判断
                            wx.onMenuShareAppMessage(shareData1)
                            wx.onMenuShareTimeline(shareData2)
                        } else {
                            wx.updateAppMessageShareData(shareData1)
                            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
                            wx.updateTimelineShareData(shareData2)
                        }
                    })           
                },
                error: data => {
                    Toast.fail(data.msg)
                }
            })
        }
    }

    
}
function _getWXSDKLocation() {
    // 解决ios下分享的时候出现的问题，这里urlencode，后端urldecode
    let callurl = window.location.href
    if (window.__wxjs_is_wkwebview && window.entryUrl) {
        callurl = window.entryUrl
    }
    // console.log('callurl',callurl)
    callurl = encodeURIComponent(callurl)    
    getMPJSAPIData({
        data: {
            url: callurl
        },
        success: data => {
            this.wxParams = data.data
            wx.config({
                debug: false,
                appId: this.wxParams.appid,
                timestamp: this.wxParams.timestamp,
                nonceStr: this.wxParams.noncestr,
                signature: this.wxParams.signature,
                jsApiList: [
                    'openLocation', // 使用微信内置地图查看位置接口
                    'getLocation' // 获取地理位置接口
                ]
            })
            wx.ready(function () {
                wx.getLocation({
                    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function (res) {
                        let latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                        let longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
                        // let speed = res.speed // 速度，以米/每秒计
                        // let accuracy = res.accuracy // 位置精度
                        // https://apis.map.qq.com/ws/geocoder/v1/?location=39.984154,116.307490&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&get_poi=1
                        tencentMap(latitude, longitude)
                    }
                })
            })
            this.setLoading(false)
        },
        error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
        }
    })
    // function baiduMap(latitude, longitude) {
        // var point = new BMap.Point(longitude, latitude)
        // var geoc = new BMap.Geocoder()
        // geoc.getLocation(point, function(rs) {
        //     var addComp = rs.addressComponents
        //     console.log(addComp.province + '' + addComp.city + '' + addComp.district + '' + addComp.street + '' + addComp.streetNumber)
        // })
    // }
    function tencentMap(latitude, longitude) {
        $.ajax({
            type: 'get',
            url: '/apo/ws/geocoder/v1',
            headers: {'Access-Control-Allow-Origin': '*'},
            data: {
                key: 'ZSXBZ-FQC6Q-TIF52-GUZIH-YWYUT-5BBRD', // 开发密钥
                location: latitude + ',' + longitude, // 位置坐标
                get_poi: '1' // 是否返回周边POI列表：1.返回；0不返回(默认)
            },
            success: function (data, textStatus) {
                console.log('textStatus：', textStatus)
                if (data.status === 0) {
                    let address = data.result.address
                    // _this.getOpenLocation(latitude, longitude, address)
                    return address
                } else {
                    alert('系统错误，请联系管理员！')
                }
            },
            error: function () {
                alert('系统错误，请联系管理员！')
            }
        })
    }
    // function getOpenLocation(latitude, longitude, address) {
    //     wx.openLocation({
    //         latitude: latitude, // 纬度，浮点数，范围为90 ~ -90
    //         longitude: longitude, // 经度，浮点数，范围为180 ~ -180。
    //         name: address, // 位置名
    //         address: '', // 地址详情说明
    //         scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
    //         infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
    //         success: function (res) {
    //             console.log(res)
    //         },
    //         fail: function (res) {
    //             console.log(res)
    //         }
    //     })
    // }
}
